import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SessionGuard } from '@com-delta-idp/mnx-oauth';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'personal-details' },
  {
    path: 'personal-details',
    loadChildren: () =>
      import('@com-delta-idp/mnx-profile-personal-details').then(
        (m) => m.SmartModule
      ),
    canLoad: [SessionGuard],
    title: 'Personal Details'
  },
  {
    path: 'companions',
    loadComponent: () =>
      import('@com-delta-idp/mnx-profile-companions').then(
        (m) => m.CompanionsComponent
      ),
    canLoad: [SessionGuard],
    title: 'Personal Details'
  },
  {
    path: 'preferences',
    loadChildren: () =>
      import('@com-delta-idp/mnx-profile-preferences').then(
        (m) => m.SmartModule
      ),
    canLoad: [SessionGuard],
    title: 'Preferences'
  },
  {
    path: 'loyalty-programs',
    loadChildren: () =>
      import('@com-delta-idp/mnx-profile-loyalty-programs').then(
        (m) => m.SmartModule
      ),
    canLoad: [SessionGuard],
    title: 'Other Loyalty Programs'
  },
  {
    path: 'companions',
    loadComponent: () =>
      import('@com-delta-idp/mnx-profile-companions').then(
        (m) => m.CompanionsComponent
      ),
    canLoad: [SessionGuard],
    title: 'Companions'
  },
  {
    path: 'payment-methods',
    loadChildren: () =>
      import('@com-delta-idp/mnx-profile-payment-methods').then(
        (m) => m.SmartModule
      ),
    canLoad: [SessionGuard],
    title: 'Payment Methods'
  },
  {
    path: 'security-settings',
    loadChildren: () =>
      import('@com-delta-idp/mnx-profile-password-security-settings').then(
        (m) => m.SmartModule
      ),
    canLoad: [SessionGuard],
    title: 'Password & Security Settings'
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
